
export default {
  clientId: process.env.REACT_APP_CLIENT_ID ?? 'collabland_dev_portal',
  apiUrl: process.env.REACT_APP_API_URL as string,
  disablePaidPlan: process.env.REACT_APP_DISABLE_PAID_PLAN === 'true'
} as const;